var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadPhotos),expression:"loadPhotos"},{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"img-scroll"},[_c('image-list',{ref:"imageList",attrs:{"list":_vm.imgList,"readOnly":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }